import {TemplateRef} from "@angular/core";
import {NzTableSize, NzTableSortFn, NzTableSortOrder} from 'ng-zorro-antd/table';
import {TABLE_CONFIG_DEFAULT} from '@app/ng-zorro/nz-config/nz-common.config';

export class AppTableHeader {
  title: string;                   // Tiêu đề
  field?: string;                  // Tên trường dữ liệu
  pipe?: string;                    // PIPE

  width?: number;                    // Width
  thTemplate?: TemplateRef<any> | string;    // th TemplateRef
  tdTemplate?: TemplateRef<any> | string;    // td TemplateRef
  fixed?: boolean;                  // fixed
  fixedDir?: string;        // fixed Bên trái hoặc phải (liên tục)
  needEllipsis?: boolean;           // truncate
  needBreakword?: boolean;           // truncate
  tdClassList?: string[];           // class thẻ TD
  thClassList?: string[];           // class thẻ TH
  show?: boolean;                   // hiển thị cột mặc định là true
  alwaysShow?: boolean;

  filterTemplate?: TemplateRef<any> | string;

  sort?: SortColumn;            // Hiển thị sort
}

export class AppTableConfig {
  needScroll?: boolean;
  size?: 'small' | 'middle' | 'default' = 'middle';
  showFrontPagination?: boolean = false;
  showCheckbox?: boolean = false; // Mặc định false, [checkCashArrayFromComment] = "cashArray" - cần có thuộc tính ID
  pageIndex?: number = 1;
  pageSize?: number = TABLE_CONFIG_DEFAULT.pageSize;
  total?: number;
  loading: boolean;
  headers: AppTableHeader[];
  showId?: boolean = true;
  bordered?: boolean = false;
  outerBordered?: boolean = false
  showSizeChanger?: boolean = false;
  pageSizeOptions?: number[] = TABLE_CONFIG_DEFAULT.pageSizeOptions;
  activeRow?: boolean = false;

  showFilter?: boolean = false;

  expand?: boolean = false;
  expandTmpl?: TemplateRef<any> | string;
}


export abstract class AppTableComponentToken {
  tableSize!: NzTableSize;
  tableConfig!: AppTableConfig;

  abstract tableChangeDetection(): void;
}

export interface SortFile {
  fileName: string;
  sortDir: undefined | 'desc' | 'asc'
}

export interface SortColumn {
  sortFn?: NzTableSortFn<any> | null;
  sortDirections?: NzTableSortOrder[];
  nzSortPriority?: number
}

